import { useNavigate, useParams } from '@tanstack/react-router';
import { memo } from 'react';

import blurredBackground from '@/assets/bg-blurred.webp';
import { Button, Heading, Logo, Text } from '@/components/core';
import { ArrowTriangleIcon, PDFIcon } from '@/components/icons';
import { CradlLogo, ExportLogo, TriggerLogo } from '@/components/logos';
import { useDots, useGetTemplate } from '@/hooks';

export type TemplateProps = object;

// eslint-disable-next-line no-empty-pattern
const ITemplate = ({}: TemplateProps) => {
  const { templateId } = useParams({ from: '/templates/$templateId' });
  const { data: template, isPending } = useGetTemplate({ templateId });
  const dots = useDots();
  const navigate = useNavigate();

  return (
    <div
      className="relative flex h-screen w-full items-center justify-center overflow-hidden bg-cover bg-center"
      style={{ backgroundImage: `url(${blurredBackground})` }}
    >
      <div className="gap-md flex w-96 flex-col items-center rounded-lg border border-gray-200 bg-white p-6 shadow-md">
        <CradlLogo size="lg" />

        <Heading>Clone agent</Heading>

        <Text>The agent will be cloned to your workspace</Text>

        <div className="flex w-full flex-col gap-2 rounded-lg border border-gray-200 bg-gray-50 p-4">
          {isPending ? (
            <Text className="font-semibold text-gray-600">Loading template {dots}</Text>
          ) : (
            <>
              <div className="flex items-center gap-2">
                <TriggerLogo functionId={template?.trigger.functionId} size="lg" />

                <ArrowTriangleIcon className="size-2 text-gray-300" rotation="right" />

                <Logo size="lg">
                  <PDFIcon />
                </Logo>

                <ArrowTriangleIcon className="size-2 text-gray-300" rotation="right" />

                <ExportLogo functionId={template?.export.functionId} size="lg" />
              </div>
              <Text className="text-xs font-semibold text-gray-600">{template?.description}</Text>
            </>
          )}
        </div>

        <Button variant="primary" onClick={() => navigate({ to: `/agents/new?template=${templateId}` })}>
          <Text>Continue</Text>
        </Button>
      </div>
    </div>
  );
};

export const Template = memo(ITemplate) as typeof ITemplate;
